export const muiStyles = () => ({
    balancesContainer: { background: 'white' },
    seeDetailsButton: {
        width: '96px',
        height: '18px',
        color: '#FFF',
        textAlign: 'center' as const,
        fontSize: '9px'
    },
    seeDetailsButtonContainer: {
        display: 'flex' as const,
        justifyContent: 'center' as const,
        width: '100%',
        backgroundColor: '#fff',
        padding: '30px 0 24px 0'
    },
    infoText: {
        padding: '24px',
        fontSize: '12px',
        fontStyle: 'italic',
        backgroundColor: '#fff',
        color: '#757575',
        '& a, a:hover, a:visited': { fontWeight: 'bold' }
    },
    agHeaderCell: {
        marginLeft: '12px',
        marginRight: '12px',
        padding: '6px'
    }
});